import { render } from "./LesTextesPage.vue?vue&type=template&id=361df95c"
import script from "./LesTextesPage.vue?vue&type=script&lang=js"
export * from "./LesTextesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__